<div
  class="message-block"
  [class.message-block--muted]="tone === 'muted'"
  [class.message-block--left]="contentPlacement === 'left'"
>
  @if (icon) {
    <div
      class="message-block__icon-wrap"
      [class.message-block__icon-wrap--featured]="featuredIcon"
    >
      <qai-icon [kind]="icon" [size]="featuredIcon ? '20px' : '24px'" class="message-block__icon" [color]="iconColor" />
    </div>
  }
  <p class="message-block__text">
    <ng-content></ng-content>
  </p>
</div>
